export const nations = [
  { key: 'Senedd', country: 'Wales' },
  { key: 'Holyrood', country: 'Scotland' },
  { key: 'Stormont', country: 'Northern Ireland' },
];
